import React from "react"

export const Hero = ({ page, backgroundImage, children }) => (
  <main className={`hero ${page && page}`} style={{ backgroundImage: `url(${backgroundImage})` }}>
    {children}
  </main>
)